<template>
  <div id = 'print' class="body_print">
    <h1 class="-page-header-title-main__title">
      {{ approvalTitle }}
    </h1>
    <div class="mrB15" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <!-- 인쇄자 -->
          <sui-input-label
            :label="$t('MSG_TXT_PRTG_USR')"
          />
        </div>
        <div class="col-xs-11">
          {{ printUserName }}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <!-- 작성자 -->
          <sui-input-label
            :label="$t('MSG_TIT_DOC_CRTR')"
          />
        </div>
        <div class="col-xs-11">
          {{ drafterSummary }}
        </div>
      </div>
      <div
        v-if="approvalAttachDocumentId !== null && approvalAttachDocumentId !== ''"
        class="row"
      >
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TIT_ATTH_FILE_NM')"
          />
        </div>
        <div class="col-xs-11">
          {{ attachFileSummary }}
        </div>
      </div>
      <div class="mrB15" />
      <div>
        <div class="comm_ListTB">
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <colgroup>
              <col width="60px">
              <col width="100px">
              <col width="*">
              <col width="220px">
              <col width="220px">
            </colgroup>
            <tr>
              <th>
                <div>{{ $t('MSG_TXT_SN') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TIT_ROL') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TXT_NAME') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TIT_PROC_DTM') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TXT_DEPT_NM') }}</div>
              </th>
            </tr>
            <template
              v-for="(user,index) in approvalUserList"
            >
              <tr
                :key="index"
              >
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.approvalParallelOrder }}
                </td>
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.rightApprovalTypeCodeName }}
                </td>
                <td>{{ `${getDisplayText(user.userDisplayLanguageId, user.approvalUserName, user.approvalUserGlobalName)}(${user.approvalUserEmail.replace(/@.*/,'')})` }}</td>
                <td>{{ user.approvalDTM | dateformatToClient }}</td>
                <td>{{ getDisplayText(user.userDisplayLanguageId, user.approvalDepartmentName, user.approvalDepartmentEnglishName) }}</td>
              </tr>
              <tr
                v-if="isUserOpinionExist(user.approvalOpinionContent)"
                :key="`10000${index}`"
              >
                <td colspan="3">
                  {{ user.approvalOpinionContent }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
    <!-- <div class="underLine"></div>    -->
    <div class="mrB30" />
    <sui-web-editor
      ref="webEditor00016"
      :isViewer="isEditorViewerMode"
      class="width100"
    />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onPrintClick"
      >
        {{ $t("MSG_BTN_PRTG") }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

/* eslint max-len: ["error", { "code" : 500 }] */
export default {
  name: 'PGE_CML_00016', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  data() {
    return {
      approvalAttachGroupId: utils.isEmpty(this.approvalAttachGroupId) ? 'ATG_CML_APRV_COMMON' : this.approvalAttachGroupId,
      approvalAttachDocumentId: '',
      approvalTitle: '',
      approvalUserList: [],
      drafterSummary: '',
      printUserName: '',
      isShownPopupDetail: false,
      attachFileSummary: '',
      isEditorViewerMode: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  methods: {
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * 상신의견 값이 존재하는지 확인하여 true/false 반환
     * check existence of approval opinion text and return true/false
     */
    isUserOpinionExist(opinion = '') {
      return utils.trim(opinion) !== '';
    },
    onLoad() {
      this.approvalUid = utils.getParameter(this, 'approvalUid');
      if (this.approvalUid) {
        this.loadApprovalInfo();
      }
    },
    loadApprovalInfo() {
      http.request(this.contextPageId, 'DTS_CML_00004', {
        path: {
          'approval-uid': this.approvalUid,
        },
      }).then(res => {
        this.approvalTitle = res.data.approvalTitle;
        this.approvalUserList = res.data.approvalUserList;
        // 작성자
        const drafter = utils.find(res.data.approvalUserList, { approvalOrder: 0 });
        this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}/${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserCareerLevelName, drafter.approvalUserCareerLevelEnglishName)}/${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserCompanyName, drafter.approvalUserCompanyEnglishName)}(${utils.dateformatToClient(res.data.approvalDraftDTM)})`;
        const attachFileNameList = [];
        utils.forEach(res.data.attachFileList, itm => {
          attachFileNameList.push(itm.fileName);
        });
        this.attachFileSummary = utils.join(attachFileNameList, ', ');
        const loginUser = this.$store.getters.userInfo;
        this.printUserName = `${this.getDisplayText(loginUser.displayLangId, loginUser.userName, loginUser.userGlobalName)}/${this.getDisplayText(loginUser.displayLangId, loginUser.departmentName, loginUser.departmentEnglishName)}/${this.getDisplayText(loginUser.displayLangId, loginUser.companyName, loginUser.companyEnglishName)}(${utils.now('YYYY-MM-DD HH:mm:ss')})`;
        this.$refs.webEditor00016.setHtml(res.data.approvalContent);
        // 첨부관련
        this.approvalAttachDocumentId = res.data.approvalAttachDocumentId;

        setTimeout(() => {
          this.onPrintClick();
        }, 500);
      });
    },
    onPrintClick() {
      // Get HTML to print from element
      /*
      const prtHtml = document.getElementById('print').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
      */

      window.print();
    },
  },
};
</script>

<style scoped>
.body_print {
    height: 100%;
    overflow:auto;
    width: 100%;
    padding: 30px;
    white-space: nowrap;
}
.underLine {border-bottom:2px solid #000000}
.col-xs-1 {background-color:#ffffff !important}
.col-xs-11 {white-space:normal !important}
.comm_ListTB td {white-space:normal !important}
</style>
